export const getRandomCid = () => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
